<template>
  <div id="assign-editor-dialog">
    <ipub-model :title="'Reviewers'"
                width="1150px"
                :visable="isVisable"
                @confirm="confirm"
                confirmText="Choose"
                @cancel="cancel">
      <div class="ipub-filter-div mar-b-10">
        <div class="ipub-filter-div-content">
          <ipub-row :gutter="[12,20]">
            <ipub-col :span="2">
              <ipub-select v-model="params.journalId"
                           @change="getList()"
                           clearable
                           placeholder="Select Journal"
                           :options="journalLists" />
            </ipub-col>
            <ipub-col :span="10">
              <div class="site-search-group mar-b-10">
                <ipub-input v-model="params.search"
                            :style="{width: `calc(100% - 120px)`}"
                            placeholder="Search by reviewer's email, name"
                            @keypress.enter.native="getList()" />
                <ipub-button class="search-group-button"
                             @click="getList()"
                             type="primary"
                             icon="iconSearch" />
                <ipub-button class="search-group-button"
                             @click="handleClear()"
                             icon="iconClear" />
              </div>
            </ipub-col>
          </ipub-row>
          <div v-if="showAdv">
            <!-- <div class="flex mar-b-12">
              <span class="line-h-40 nowrap fw-bd"
                    style="width:200px">Exclude Country / Territory</span>
              <ipub-select search
                           :clear="true"
                           @change="getList()"
                           @search="countrySearch"
                           class="mar-l-10"
                           style="width: calc(100% - 200px)"
                           placeholder="Select country / territory"
                           v-model="params.countryCode"
                           mode="multiple">
                <ipub-select-option v-for="item in countryList"
                                    :value="item.code"
                                    :key="'countryList'+item.code">
                  {{item.name}} <template v-if="item.otherName">({{item.otherName}})</template>
                </ipub-select-option>
              </ipub-select>
            </div> -->
            <!-- <div class="flex mar-b-12">
              <span class="line-h-40"
                    style="width:90px">Classifications</span>
              <ipub-select placeholder="Personal Classification"
                           :options="categoryList"
                           mode="multiple"
                           style="width: calc(100% - 100px)"
                           :tree="true"
                           class="mar-l-10"
                           optionKey="id"
                           v-model="params.categoryIdList" />
            </div> -->
            <div class="flex mar-b-10">
              <span class="line-h-40 fw-bd">Keywords</span>
              <div style="width:100%">
                <ipub-input v-model.trim="keywords"
                            tag
                            class="mar-l-10"
                            placeholder="Search by keywords"
                            @clear="handleClear" />
              </div>
            </div>
            <div class="mar-b-12">
              <ipub-radio :checked="params.historyReviewer"
                          @change="(e)=>{params.historyReviewer = !e;getList()}">Review completed in historical version</ipub-radio>
              <!-- <ipub-radio :checked="params.declinedReviewer"
                          @change="(e)=>{params.declinedReviewer = !e;getList()}">Rejected Reviewer in current version</ipub-radio> -->
              <ipub-radio :checked="params.eboard"
                          @change="(e)=>{params.eboard = !e;getList()}">Editorial Board</ipub-radio>
              <ipub-radio :checked="params.guest"
                          @change="(e)=>{params.guest = !e;getList()}">Guest Editor</ipub-radio>
              <ipub-radio :checked="params.suggested"
                          @change="(e)=>{params.suggested = !e;getList()}">Suggested Reviewer</ipub-radio>
            </div>
          </div>
        </div>
        <a class="ipub-filter-div-button line-h-40"
           @click="()=>{showAdv = !showAdv}">
          Advanced
          <ipub-icon :class="['mar-l-10 rotate',showAdv?'rotate-180':'']"
                     type="iconArrow" />
        </a>
      </div>
      <div class="mar-b-10 ipub-p2">
        <ipub-label :style="{margin: '0 16px 16px 0'}"
                    v-for="(item, index) in selectdList"
                    :key="'selectdList'+index"
                    size="common"
                    class="ipub-c-p"
                    circle
                    cover>
          {{item.firstName}} {{item.lastName}}
          <ipub-icon class="mar-l-10"
                     @click="remove(item)"
                     type="iconClose" />
        </ipub-label>
      </div>
      <div class="page-content">
        <ipub-table :columns="columns"
                    border
                    @order="onOrderChanage"
                    :pagination="pagination"
                    :dataSource="dataSource">
          <template v-slot:hindex="{text,record}">
            <font class="ipub-p2">{{text}}</font>
            <ipub-tooltip style="width:100%"
                          class="mar-l-10 ipub-p2">
              <div slot="title">
                <font v-if="record.hindexUrl">H-Index URL</font>
                <font v-else>Link to Scopus</font>
              </div>
              <a :href="record.hindexUrl"
                 @click="openLink(record)"
                 target="_blank">
                <ipub-icon type="iconReference"
                           class="link-color" />
              </a>
            </ipub-tooltip>
          </template>
          <template v-slot:select="{record}">
            <ipub-radio @change="(e)=>{onCheckChange(e, record.id)}"
                        :checked="record.id === params.editorId" />
          </template>
          <template v-slot:categoryList="{text}">
            <ipub-tooltip v-if="text && text.length"
                          style="width:100%">
              <div slot="title">
                {{text.map((item)=>{return item.name}).join(', ')}}</div>
              <div class="omission-2">
                {{text.map((item)=>{return item.name}).join(', ')}}</div>
            </ipub-tooltip>
            <template v-else>- -</template>
          </template>
          <template v-slot:country="{text}">
            <ipub-tooltip style="width:100%"
                          v-if="text">
              <div slot="title">{{country[text]}}</div>
              <div class="omission-2">{{country[text]}}</div>
            </ipub-tooltip>
            <font v-else>--</font>
          </template>
          <template v-slot:name="{record}">
            <div>
              <a style="margin-right:10px"
                 class="link-color"
                 @click="openLink(record,'person')">{{record.email}}</a>
              <ipub-tooltip v-if="record.remark"
                            class="ipub-c-p">
                <div slot="title">{{record.remark}}</div>
                <ipub-icon type="icona-ManuscriptNote"
                           class="mar-l-10" />
              </ipub-tooltip>

              <div class="ipub-p1">
                <div>
                  <ipub-label v-if="record.authored"
                              size="small"
                              style="margin-right:10px"
                              type="danger">
                    AUTHOR
                  </ipub-label>
                  <template v-if="record.roleList&&record.roleList.length">
                    <div class="mar-b-6">
                      <ipub-label v-if="record.ebed"
                                  size="small"
                                  style="margin-right:6px">
                        EB
                      </ipub-label>
                      <ipub-label v-if="record.rbed"
                                  size="small"
                                  style="margin-right:6px">
                        RB
                      </ipub-label>
                      <ipub-label v-if="record.geed"
                                  size="small"
                                  style="margin-right:6px">
                        GE
                      </ipub-label>
                      <ipub-label v-if="record.suggested"
                                  size="small"
                                  style="margin-right:6px"
                                  type="danger">
                        Suggest
                      </ipub-label>
                    </div>
                    <ipub-tooltip placement="right"
                                  v-if="record.affed">
                      <div slot="title">This reviewer and the author belongs to the same Affiliation.</div>
                      <div class="ipub-label key-bg content-color color-label">
                        Same Affiliations
                      </div>
                    </ipub-tooltip>
                  </template>
                  <template v-if="record.mailListTypeList&&record.mailListTypeList.length">
                    <template v-for="item in record.mailListTypeList">
                      <ipub-label v-if="item==='PUBLISHER_BLACKLIST'"
                                  :key="record.id+'record.mailListTypeList'+item"
                                  size="small"
                                  style="margin-right:10px"
                                  type="warning">
                        Blacklist
                      </ipub-label>
                    </template>
                  </template>
                  <template v-if="record.lastMinvitedTime && $moment().diff($moment(record.lastMinvitedTime), 'days')+1<publisherInfo.reviewLimitDay">
                    <!-- <div>
                      <div class="ipub-label key-bg content-color color-label"
                           style="margin-right:10px">
                        Less than {{publisherInfo.reviewLimitDay}} days
                      </div>
                    </div> -->
                    <ipub-tooltip placement="bottomLeft">
                      <div slot="title">
                        <div v-if="showReviewTimeInfo && showReviewTimeInfo.length">
                          <div v-for="(itemInfo,indexInfo) in showReviewTimeInfo"
                               :key="itemInfo.id+indexInfo">
                            {{itemInfo.invitedEditor && itemInfo.invitedEditor.firstName}} {{itemInfo.invitedEditor && itemInfo.invitedEditor.lastName}} ({{itemInfo.invitedEditor && itemInfo.invitedEditor.email}}) of the Manuscript ({{itemInfo.code}}) has invited on {{itemInfo.invitedTime?$moment(itemInfo.invitedTime).format('HH : mm DD / MM / YYYY'):'- -'}}.
                          </div>
                        </div>
                        <span v-else>--</span>
                      </div>
                      <ipub-label size="small"
                                  type="danger"
                                  style="margin-right:10px"
                                  active
                                  @mouseover="overReviewTime(record)">
                        <!-- Less {{$moment().diff($moment(item.lastReviewTime), 'days')}} days -->
                        Less than {{publisherInfo.reviewLimitDay}} days
                      </ipub-label>
                    </ipub-tooltip>

                  </template>
                </div>
                <font class="key-color ipub-p4"
                      style="margin-right:10px"
                      v-if="record.declinedReviewerList&&record.declinedReviewerList.length">
                  <ipub-icon style="font-size:20px"
                             type="iconreviewer" />
                  <template v-for="(val, num) in record.declinedReviewerList">
                    <ipub-tooltip :key="'too'+val.id"
                                  placement="bottomLeft">
                      <div slot="title">
                        <div class="ipub-p3">
                          {{reviewRefuse[val.reasonCode]}}
                        </div>
                        <div class="ipub-p4">{{val.reason}}</div>
                      </div>
                      <a :key="val.id"
                         href="">
                        V{{val.sign}}<template v-if="num !== record.declinedReviewerList.length-1">,</template>
                      </a>
                    </ipub-tooltip>
                  </template>
                </font>
                <font class="warning-color ipub-p4"
                      style="margin-right:10px"
                      v-if="record.adoptedReviewerList&&record.adoptedReviewerList.length">
                  <ipub-tooltip placement="bottomLeft">
                    <div slot="title">
                      Unaccepted Report
                    </div>
                    <ipub-icon style="font-size:20px"
                               type="icona-RejectReviewer" />
                  </ipub-tooltip>
                  <template v-for="(val, num) in record.adoptedReviewerList">
                    <a :key="val.id"
                       href="">
                      V{{val.sign}}<template v-if="num !== record.adoptedReviewerList.length-1">,</template>
                    </a>
                  </template>
                </font>
                <font class="link-color ipub-p4"
                      style="margin-right:10px"
                      v-if="record.historyReviewerList&&record.historyReviewerList.length">
                  <ipub-tooltip placement="bottomLeft">
                    <div slot="title">
                      Review completed in historical version
                    </div>
                    <ipub-icon style="font-size:20px"
                               type="icona-AcceptReviewer" />
                  </ipub-tooltip>
                  <template v-for="(val, num) in record.historyReviewerList">
                    <a :key="val.id"
                       href="">
                      V{{val.sign}}<template v-if="num !== record.historyReviewerList.length-1">,</template>
                    </a>
                  </template>
                </font>
              </div>
            </div>
          </template>
          <template v-slot:actions="{ record }">
            <div v-if="selectdList.map(item=>{return item.personId}).includes(record.personId)">
              <ipub-icon type="iconDisable"
                         @click="remove(record)" />
            </div>
            <div v-else>
              <ipub-icon type="iconAble"
                         @click="add(record)" />
            </div>
          </template>
        </ipub-table>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { settingCountry } from '@/api/setting'
import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group.vue'
import section from '@/api/section'
import { minvitedReviewer } from '@/api/reviewer'
import person from '@/api/person'
import journal from '@/api/journal'
import help from '@/utils/help'


const columns = [
  // {
  //   title: '',
  //   enTitle: 'Name',
  //   width: 200,
  //   dataIndex: 'name',
  //   slot: 'name'
  // },
  {
    title: '',
    enTitle: 'Email',
    width: 200,
    dataIndex: 'email',
    slot: 'name'
  },
  {
    title: '',
    enTitle: 'Country',
    width: 150,
    dataIndex: 'countryCode',
    slot: 'country'
  },
  // {
  //   title: '',
  //   enTitle: 'Classification',
  //   width: 200,
  //   dataIndex: 'categoryList',
  //   slot: 'categoryList'
  // },
  {
    title: '',
    enTitle: 'Latest Review',
    width: 120,
    dataIndex: 'lastReviewTime',
    sort: true,
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Invited',
    width: 70,
    dataIndex: 'invitedNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'H-index',
    width: 100,
    dataIndex: 'hindex',
    sort: true,
    slot: 'hindex'
  },
  {
    title: '',
    enTitle: 'Reviewed',
    width: 80,
    sort: true,
    dataIndex: 'reviewNum',
  },
  {
    title: '',
    enTitle: 'Reviewing',
    width: 80,
    dataIndex: 'agreedNum',
  },
  {
    title: '',
    enTitle: 'Add',
    width: 70,
    dataIndex: 'actions',
    slot: 'actions'
  }
]
export default {
  components: { SiteSearchGroup },
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
    journalList: {
      type: Array,
      default () {
        return []
      }
    },
  },
  data () {
    return {
      columns,
      showAdv: false,
      params: {
        sorted: '',
        eboard: false,
        guest: false,
        suggested: false,
        historyReviewer: false,
        declinedReviewer: false,
        search: '',
        journalId: ''
        // keyword: ''
      },
      dataSource: [],
      countryList: [],
      categoryList: [],
      selectdList: [],
      pagination: {
        total: 0,
        size: 10,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      showReviewTimeInfo: {},
      keywords: [],
      journalLists: []
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      country: 'getCountry',
      reviewRefuse: 'getReviewRefuse',
      publisherInfo: 'getPublisherInfo',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {
          eboard: false,
          guest: false,
          suggested: false,
          historyReviewer: false,
          declinedReviewer: false,
          keyword: '',
          search: '',
          journalId: ''
        }
        this.keywords = []
      } else {
        this.params.manuscriptId = this.inputData.id
        this.params.sign = this.inputData.sign
        // this.params.journalId = this.inputData.journalId
        this.selectdList = JSON.parse(JSON.stringify(this.inputData.selectdList))
        this.getSection()
        this.getList()
      }
      this.getJournal()
    }
  },
  mounted () {
    this.countrySearch()
  },
  methods: {
    async getList (page = 1) {
      const { sorted, countryCode, categoryIdList, eboard, guest, suggested, historyReviewer, declinedReviewer, search, journalId } = this.params
      const { id, sign } = this.inputData
      let keyword = this.keywords && this.keywords.length ? this.keywords.join(',') : ''
      const data = {
        sorted,
        pageIndex: page,
        pageSize: this.pagination.size,
        excludeCountryCodeList: (countryCode && countryCode.length) ? countryCode.join(',') : '',
        eboard, guest, suggested, historyReviewer, declinedReviewer,
        search,
        categoryIdList: (categoryIdList && categoryIdList.length) ? categoryIdList.join(',') : '',
        sign,
        keyword,
        journalId,
        manuscriptId: id
      }
      // console.log(this.params, data, 'll')
      const { list, pageIndex, pageSize, total } = await minvitedReviewer.search(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    async getJournal () {
      const journalList = await journal.allName()
      this.journalLists = journalList
    },
    async confirm () {
      this.$emit('confirm', this.selectdList)
    },
    cancel () {
      this.$emit('cancel')
    },
    handleClear () {
      this.params = {
        eboard: false,
        reviewer: false,
        historyReviewer: false,
        declinedReviewer: false,
        journalId: ''
      }
      this.keywords = []
      this.getList()
    },
    async getSection () {
      this.categoryList = await section.getAll()
    },
    async countrySearch (val) {
      this.countryList = await settingCountry.getAll({
        keyword: val
      })
    },
    add (val) {
      this.selectdList.push(val)
    },
    remove (val) {
      const index = this.selectdList.findIndex(item => {
        return item.id === val.id
      })
      if (index === -1) {
        return
      }
      this.selectdList.splice(index, 1)
    },
    onOrderChanage (val) {
      this.params.sorted = val
      this.getList()
    },
    async overReviewTime (val) {
      let params = {
        invitedTimeStart: this.$moment().subtract(
          this.publisherInfo.reviewLimitDay,
          'days'
        ),
        invitedTimeEnd: this.$moment()
      }
      const data = await person.rmanuscript(val.personId, params)
      this.showReviewTimeInfo = data.length > 3 ? data.slice(0, 3) : data
    },
    openLink (record, type) {
      let link = ''
      if (type === 'person') {
        link = `/user-manage/manage-users/${record.personId}/related-manuscripts?title=REPORTS`
      } else {
        link = record.hindexUrl ? record.hindexUrl : `https://www.scopus.com/results/authorNamesList.uri?s=AUTHLASTNAME%28${record.lastName}%29+AND+AUTHFIRST%28${record.firstName}%29&st1=${record.lastName}&st2=${record.firstName}`
      }
      help.openWindow(link)
    }
  }
}
</script>

<style lang="scss" scoped>
.color-label {
  color: $content_color;
}
.site-search-group {
  display: flex;
  justify-content: space-between;
  .search-group-button {
    width: 40px;
    padding: 0;
    font-size: 28px;
    margin-left: 20px;
  }
}
.clickBlock {
  width: 70px;
}
</style>
